<a mat-button class="has-icon link" href="{{ linkUrl() }}" color="primary">
  <mulo-orcid-logo></mulo-orcid-logo>
  {{ linkText() }}
</a>
@if (description) {
  <p [innerHTML]="description"></p>
}
